import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Capabilities from '../components/Capabilities';
import BuiltFor from '../components/BuiltFor';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0b] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Capabilities />
        <BuiltFor />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
